export interface IEntity {
  id: number;
}

export class BaseEntity implements IEntity {
  id: number;
  createdAt?: string;
  updatedAt?: string;
}
